import React from "react";
import { Carousel, CarouselItem, CarouselControl } from "reactstrap";

const BANNERS = [
  {
    id: 1,
    title: "Karadeniz Turları %30 İndirimli",
    subtitle: "Sınırlı süre — hemen rezerve edin!",
    bg: "bg-gradient-success",
  },
  {
    id: 2,
    title: "Rize Çay Bahçeleri Deneyimi",
    subtitle: "Doğanın kalbinde unutulmaz bir gün",
    bg: "bg-gradient-info",
  },
  {
    id: 3,
    title: "Trabzon Uzungöl Otel Fırsatları",
    subtitle: "Erken rezervasyona özel fiyatlar",
    bg: "bg-gradient-primary",
  },
];

export default function AdBannerSlider() {
  const [activeIndex, setActiveIndex] = React.useState(0);
  const [animating, setAnimating] = React.useState(false);

  const next = () => {
    if (animating) return;
    setActiveIndex((i) => (i === BANNERS.length - 1 ? 0 : i + 1));
  };

  const previous = () => {
    if (animating) return;
    setActiveIndex((i) => (i === 0 ? BANNERS.length - 1 : i - 1));
  };

  return (
    <Carousel activeIndex={activeIndex} next={next} previous={previous} className="mb-4">
      {BANNERS.map((b) => (
        <CarouselItem key={b.id} onExiting={() => setAnimating(true)} onExited={() => setAnimating(false)}>
          <div className={`${b.bg} rounded p-4 text-white`} style={{ minHeight: 140 }}>
            <h3 className="text-white mb-1">{b.title}</h3>
            <p className="mb-0 opacity-8">{b.subtitle}</p>
          </div>
        </CarouselItem>
      ))}
      <CarouselControl direction="prev" directionText="Önceki" onClickHandler={previous} />
      <CarouselControl direction="next" directionText="Sonraki" onClickHandler={next} />
    </Carousel>
  );
}
